import * as React from 'react';
import styled from 'styled-components';

type Props = {
  name: string;
  hasBackground: boolean;
};

const SUPPORTED_ICONS = {
  check: (
    <g
      id="check"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline
        id="Path"
        stroke="currentColor"
        strokeWidth="2.2"
        points="2 19.5 11 28.5 30 3.5"
      ></polyline>
    </g>
  ),
  chat: (
    <g
      id="chat"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        d="M12.0474722,3.15375359 C6.86254948,3.15375359 2.65986673,7.35643635 2.65986673,12.5413591 C2.65986673,14.2607732 3.13023517,15.8675359 3.93756924,17.2539371 L1.67169773,22.9171336 L7.33489427,20.6512621 C8.72129537,21.4585961 10.3280582,21.9289646 12.0474722,21.9289646 C17.232395,21.9289646 21.4350777,17.7262818 21.4350777,12.5413591 C21.4350777,7.35643635 17.232395,3.15375359 12.0474722,3.15375359 L12.0474722,3.15375359 Z"
        id="Stroke-38"
        stroke="currentColor"
        strokeWidth="1.2"
      ></path>
      <path
        d="M12.2981707,23.8925552 C13.9988096,26.288865 16.790387,27.8580774 19.9525278,27.8580774 C21.6719418,27.8580774 23.2787046,27.387709 24.6651057,26.5803749 L30.3283023,28.8462464 L28.0634189,23.1820617 C28.870753,21.7966488 29.3401333,20.189886 29.3401333,18.4704719 C29.3401333,14.3587007 26.6928285,10.8724405 23.011899,9.6026433"
        id="Stroke-40"
        stroke="currentColor"
        strokeWidth="1.2"
      ></path>
    </g>
  ),
  shield: (
    <g
      id="shield"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        d="M4.844759,2.90471708 L4.844759,16.6111132 C4.844759,23.9755123 16,30.0653039 16,30.0653039 C16,30.0653039 27.155241,23.9755123 27.155241,16.6111132 L27.155241,2.90471708 L27.0097379,2.90471708 C25.7108798,4.844759 23.9958827,4.99608227 22.1159821,4.99608227 C19.562887,4.99608227 17.3134084,3.91353888 15.99903,1.93469613 L16.00097,1.93469613 C14.6865916,3.91353888 12.437113,4.99608227 9.88401787,4.99608227 C8.00411725,4.99608227 6.2891202,4.844759 4.99026214,2.90471708 L4.844759,2.90471708 Z"
        id="Stroke-1921"
        stroke="currentColor"
        strokeWidth="1.2"
      ></path>
      <polyline
        id="Stroke-1922"
        stroke="currentColor"
        strokeWidth="1.2"
        points="11.6349057 14.5449686 14.378125 18.4250524 20.3650943 11.6349057"
      ></polyline>
    </g>
  ),
  germany: (
    <g
      id="germany"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M2.87078906,11.1304609 C2.30805469,12.6471641 2,14.2875156 2,16 C2,17.7124844 2.30805469,19.3529453 2.87078906,20.8695391 L16,20.9 L29.1292109,20.8695391 C29.6919453,19.3529453 30,17.7124844 30,16 C30,14.2875156 29.6919453,12.6471641 29.1292109,11.1304609 L16.000082,11.1304609 L2.87078906,11.1304609 Z"
        id="Path"
        fill="#F01515"
        fillRule="nonzero"
      ></path>
      <path
        d="M16,2 C9.98054688,2 4.84889063,5.79925 2.87084375,11.1304609 L29.1293203,11.1304609 C27.1511094,5.79925 22.0195625,2 16,2 Z"
        id="Path"
        fill="#262626"
        fillRule="nonzero"
      ></path>
      <path
        d="M16,30 C22.0195625,30 27.1511094,26.20075 29.1292656,20.8695391 L2.87084375,20.8695391 C4.84889063,26.20075 9.98054688,30 16,30 Z"
        id="Path"
        fill="#FFD421"
        fillRule="nonzero"
      ></path>
    </g>
  ),
};

const IconRoot = styled.svg<{ hasBackground: boolean }>(
  ({ theme, hasBackground }) => ({
    color: theme.white,
    backgroundColor: hasBackground ? theme.blue15 : 'transparent',
    borderRadius: '50%',
    padding: hasBackground ? '4px' : '',
    minWidth: '24px',

    '& > g#shield, & > g#chat': {
      color: theme.blue01,
      opacity: 0.8,
    },

    '& > g#check': {
      color: theme.blue07,
    },
  })
);

const Icon: React.FC<Props> = ({ name, hasBackground }) => {
  // @ts-ignore
  return SUPPORTED_ICONS[name] ? (
    <IconRoot
      width="24px"
      height="24px"
      viewBox="0 0 32 32"
      hasBackground={hasBackground}
    >
      {/**
       // @ts-ignore */}
      {SUPPORTED_ICONS[name]}
    </IconRoot>
  ) : null;
};

export default Icon;
